'use strict';
import angular from 'angular';

import shoppingAdgroupMultiproductHtmlUrl from './views/shoppingAdgroupMultiproduct.list.html';

var app = angular.module('app.shoppingAdgroupMultiproductComponents', []);

app.component('shoppingAdgroupMultiproduct', {
    bindings: {
        clientId: '=',
        clusterId: '=',
        productId: '=',
        lookup: '=',
        adgroupMultiproduct: '=',
        showActions: "=",
        formData: "=",
        isEdit:"="
    },
    templateUrl: shoppingAdgroupMultiproductHtmlUrl,

    // The controller that handles our component logic
    controller: function ($ioAlert, anchorSmoothScroll, $location, ProductService, $timeout) {
        var self = this;
        self.adGroupShowcaseFormObj = { type: "showcase" };
        self.adGroup = {};
        self.adTypeObj = { creativeImages: [] };
        self.keywordMatchTypes = ["Exact", "Phrase", "Broad"];
        self.adTypes = ["SHOWCASE_AD", "EXPANDED_DYNAMIC_SEARCH_AD", "IMAGE_AD", "CALL_ONLY_AD", "SHOWCASE_AD", "PRODUCT_AD"];
        self.showAdGroupForm = false;
        self.showAdTypeForm = false;
        self.adGroupStatus = ["ENABLED", "PAUSED", "REMOVED"];
        self.groupSlides = [
            { "name": "adgroup" },
            { "name": "adtype" }
        ];
        self.isAdGroup = true;
        self.isAdType = false;
        self.value = "";
        self.inventorydata = [];

        self.filterObj = {};
        self.inventoryKeys = [];
        self.filterdata = [];
        self.selected = "";
        self.disabled = {};
        self.selectedFieldData = [{ colId: 'col1', attributeType: '', attributeValue: '', isDisabled: false, isHide: false,status:"Included" }];

        // Method for getting showcase shopping API Data
        self.getInventoryFilterAPIData = function (getProductList, merchantId) {
            ProductService.getExistingProductLists(getProductList, merchantId).then(function (response) {
                self.inventorydata = response;
                self.inventoryKeys = _.keys(self.inventorydata[0]);
            }, function (error) {
                $rs.loadingInProgress = false;
            });
        }

        // Method for getting Merchant ID
        self.getMerchantId = function () {
            ProductService.getProductDfpKeys(self.clientId, self.clusterId, self.productId, self.lookup).then(function (data) {
                data.productFields.forEach(function (product) {
                    if (product.field_name == 'merchant_center_account') {
                        product.lookup_content.forEach(function (lookups) {
                            self.merchantid = lookups.lookup_value;
                        });
                    }
                });
                self.getInventoryFilterAPIData("GET_PRODUCT_LIST", self.merchantid);
            }, function (error) {
                console.log("error getting Inventory Filters API Data");
            });
        }

        //Show AdType by Sliding to the AdType View
        self.viewAdType = function (adgroup) {
            self.adGroup = adgroup;
            self.isAdGroup = false;
            self.showAdGroupForm = false;
            self.isAdType = true;
            //If there are no Adds create an Empty Array
            if (!self.adGroup.ads) {
                self.adGroup.ads = [];
            };
            if (self.adGroup.ads && self.adGroup.ads.length == 0 && self.showActions) {
                self.addAdType();
            };
        };

        //Show Ad Group Screen 
        self.backToAdGroup = function () {
            self.isAdGroup = true;
            self.isAdType = false;
            self.adGroup = {};
        }

        // Initialise Add group Form
        self.initAdGroup = function () {
            self.adGroupShowcaseFormObj = {
                adGroupName: "",
                adGroupStatus: "",
                type: "showcase"
            };
        }

        //Show Add Group form 
        self.newAdGroup = function () {
            self.initAdGroup();
            self.selectedFieldData = [{ colId: 'col1', attributeType: '', attributeValue: '', isDisabled: false, isHide: false,status:"Included"}];
            self.showAdGroupForm = true;
            self.showAdTypeForm = false;
            self.isNewGroup = true;
        };

        //Hide Ad Group Form
        self.cancelAdGroup = function () {
            self.showAdGroupForm = false;
            self.initAdGroup();
        }

        self.changeText = function(col){
            if(col.status=="Included"){
                col.status ="Excluded";
            }else{
                col.status = "Included";
            }
        }

        // Edit Ad Group Form
        self.editAdGroup = function (adGroupShowcaseFormObj, index) {
            self.showAdGroupForm = true;
            self.showAdTypeForm = false;
            self.adGroupShowcaseFormObj = angular.copy(adGroupShowcaseFormObj);
            self.selectedFieldData = self.adGroupShowcaseFormObj.selectedProducts;
            if(self.adGroupShowcaseFormObj.useall == "selection"){
                var resultData = ProductService.productFields.filter(obj => {
                    return obj.input_type === "inventory-filter"
                })
                if (resultData && resultData.length > 0) {
                    if (self.formData[resultData[0].field_name].length == 1 && self.formData[resultData[0].field_name][0].attributeType == "") {
                        self.filterObj ={};
                    } else {
                        var modelData = self.formData[resultData[0].field_name];
                    }
                }
                if(modelData){
                    _.each(modelData, function (item) {
                        self.filterObj[item.attributeType] = item.attributeValue;
                    })
                }
            }
            self.groupIndex = index;
            self.isNewGroup = false;
            $location.hash('top-scroll-showcase');
            anchorSmoothScroll.scrollTo('top-scroll-showcase');
            $timeout(function () {
                $location.hash('');
            }, 500);
        }

        // Save AdGroup form
        self.saveAdGroup = function (form) {
            if (self.adGroupShowcaseFormObj && self.adGroupShowcaseFormObj.adGroupName != "" && self.adGroupShowcaseFormObj.adGroupName != undefined && self.adGroupShowcaseFormObj.adGroupStatus != "" && self.adGroupShowcaseFormObj.ad_group_cpc_bid != "" && self.adGroupShowcaseFormObj.ad_group_cpc_bid != undefined) {
                if (self.adGroupShowcaseFormObj.useall == "selection") {
                    if(self.selectedFieldData[0].attributeType !== ""){
                        self.adGroupShowcaseFormObj.selectedProducts = self.selectedFieldData;
                    }
                    else{
                        $ioAlert.show('', 'Please fill the required fields', 'error');
                        return;
                    }
                } else {
                    delete self.adGroupShowcaseFormObj["selectedProducts"];
                }

                if (self.isNewGroup === false) {
                    self.adgroupMultiproduct[self.groupIndex] = self.adGroupShowcaseFormObj;
                } else {
                    if (!self.adgroupMultiproduct) {
                        self.adgroupMultiproduct = [];
                    };
                    self.adgroupMultiproduct.push(self.adGroupShowcaseFormObj);
                }
                self.showAdGroupForm = false;
                self.initAdGroup();
            } else {
                $ioAlert.show('', 'Please fill the required fields', 'error');
            }
        }

        // Delete Ad Group Helper function
        self.delAdGroup = function (index) {
            self.showAdGroupForm = false;
            self.adgroupMultiproduct.splice(index, 1);
            if (self.adgroupMultiproduct.length == 0) {
                self.newAdGroup();
            }
        }

        self.selectAttrType = function (item) {
            if (self.selectedFieldData.length == 1 && _.isEmpty(self.filterObj)) {
                self.filterdata = _.map(self.inventorydata, item.attributeType);
            }
            else {
                var dataByParent = _.filter(self.inventorydata, self.filterObj);
                self.filterdata = _.map(dataByParent, item.attributeType);
            }
            item.attributeValue = '';
            var filtercount = self.filterdata.reduce(function (obj, b) {
                obj[b] = ++obj[b] || 1;
                return obj;
            }, {});
            self.filterdata = _.uniq(self.filterdata)
            _.map(self.filterdata, function (item, index) {
                var t = filtercount[item];
                self.filterdata[index] = item + " " + "(" + t + " " + "Products" + ")";
            });
        }

        self.onSelect = function (model, item) {
            item.attributeValue = model.replace(/\s*\([^)]+\)(?![^(]*\()/g, "");
        }

        self.removeColumn = function (item, index) {
            self.selectedFieldData = [{ colId: 'col1', attributeType: '', attributeValue: '', isDisabled: false, isHide: false ,status:"Included"}];
            self.filterdata = [];
        }

        self.addNewColumn = function (item) {
            item.isDisabled = true;
            item.isHide = true;
            self.filterdata = [];
            self.filterObj[item.attributeType] = item.attributeValue;
            var newItemNo = self.selectedFieldData.length + 1;
            self.selectedFieldData.push({ 'colId': 'col' + newItemNo, attributeType: '', attributeValue: '', isDisabled: false, isHide: false,status:"Included" });
        }

        self.refreshFilterData = function (item) {
            if (item.attributeValue == "") {
                self.selectKey(item);
            }
        }

        /*
         * Update AdType Helper function to toggle Image Ad and expanded ad
         */
        self.updateAdType = function (type) {
            self.adTypeObj = { };
        };

        /*
         * Display Show AdType form
         */
        self.addAdType = function () {
            self.showAdTypeForm = true;
            self.isNewAd = true;
            self.adTypeObj = {};
        };

        /** Load Inventory Filter Data*/
        self.loadInventoryData = function () {
            if (!self.selectedFieldData) {
                self.selectedFieldData = [{ colId: 'col1', attributeType: '', attributeValue: '', isDisabled: false, isHide: false,status:"Included"  }];
            }
            var resultData = ProductService.productFields.filter(obj => {
                return obj.input_type === "inventory-filter"
            })
            if (resultData && resultData.length > 0) {
                if (self.formData[resultData[0].field_name].length == 1 && self.formData[resultData[0].field_name][0].attributeType == "") {
                    return;
                } else {
                    var modelData = self.formData[resultData[0].field_name];
                }
            }
            _.each(modelData, function (item) {
                self.filterObj[item.attributeType] = item.attributeValue;
            })
        };

        /*
         * Display Edit Ad Type form
         */
        self.editAdType = function (ad, index) {
            self.showAdTypeForm = true;
            self.adTypeObj = angular.copy(ad);
            self.isNewAd = false;
            self.adIndex = index;
        }

        /*
         * Save/Edit Ad Type and update the AdGroup object
         */
        self.saveAdType = function (form) {
            if (form.$valid) {
                if (_.isEmpty(self.adTypeObj.description)) {
                    var isvalidated = true;
                } else {
                    if (self.adTypeObj.description.length >= 80) {
                        var isvalidated = true;
                    }
                    else {
                        var isvalidated = false;
                    }
                }
                if (isvalidated) {
                    if (self.adGroup) {
                        if (!self.adGroup.ads) {
                            self.adGroup.ads = [];
                        }
                        if (self.isNewAd) {
                            self.adGroup.ads.push(self.adTypeObj);
                        } else {
                            self.adGroup.ads[self.adIndex] = self.adTypeObj;
                        }
                        self.showAdTypeForm = false;
                        self.adTypeObj = {};
                    }
                } else {
                    $ioAlert.show('', 'Description must be at least 80 characters long.', 'error');
                }
            } else {
                $ioAlert.show('', 'Please fill the required fields', 'error');
            }
        }


        /*
         * Delete Ad Type
         */
        self.delAdType = function (index) {
            self.showAdTypeForm = false;
            self.adGroup.ads.splice(index, 1);
        }

        /*
         * Cancel AdType form 
         */
        self.cancelAdType = function () {
            self.showAdTypeForm = false;
            self.adTypeObj = {};
        }

        /* 
         * Initialize the component hide the add/edit operations based on showActions boolean value
         */
        self.initComponent = function () {
            if(self.showActions){
                self.getMerchantId();
            }
            if (self.adgroupMultiproduct) {
                if (typeof self.adgroupMultiproduct == "string" && self.adgroupMultiproduct !== "") {
                    self.adgroupMultiproduct = JSON.parse(self.adgroupMultiproduct);
                    self.initAdGroup();
                } else if (self.adgroupMultiproduct.length > 0) {
                    self.initAdGroup();
                } else {
                    self.newAdGroup();
                }
            } else if (self.showActions) {
                self.adgroupMultiproduct = [];
                self.newAdGroup();
            }
        };

        self.initComponent();
    }
});
